<div class="edge-panel" [class.is-open]="open" *ngIf="visible">

  <!-- Fondo: cierra el panel al hacer click afuera -->
  <div class="edge-panel-backdrop" *ngIf="open" (click)="close()"></div>

  <!-- Manija del borde izquierdo, siempre visible -->
  <button type="button" class="edge-panel-handle"
          (click)="toggle()"
          [attr.aria-expanded]="open"
          [attr.aria-label]="titleKey | translate">
    <span class="edge-panel-grip"></span>
    <i class="feather" [ngClass]="open ? 'icon-chevron-left' : 'icon-chevron-right'"></i>
  </button>

  <!-- Panel deslizante -->
  <aside class="edge-panel-body" role="dialog" [attr.aria-hidden]="!open">

    <div class="edge-panel-head">
      <h6 class="edge-panel-title">
        <i class="feather mr-50" [ngClass]="titleIcon"></i>
        {{ titleKey | translate }}
      </h6>
      <button type="button" class="edge-panel-close" (click)="close()"
              [attr.aria-label]="'COMMON.BUTTONS.CLOSE' | translate">
        <i class="feather icon-x"></i>
      </button>
    </div>

    <div class="edge-panel-search">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input type="text" [placeholder]="'COMMON.ACTIONS.SEARCH' | translate"
             [(ngModel)]="searchTerm" name="edgePanelSearch" (input)="onSearch()" />
      <button *ngIf="searchTerm" type="button" class="edge-panel-search-clear" (click)="clearSearch()">
        <i class="feather icon-x"></i>
      </button>
    </div>

    <div class="edge-panel-tree">
      <ng-container *ngIf="!loading; else loadingTpl">
        <ng-container *ngIf="nodes.length > 0; else emptyTpl">
          <ng-container *ngTemplateOutlet="nodeTpl; context: { nodes: nodes, level: 0 }"></ng-container>
        </ng-container>

        <ng-template #emptyTpl>
          <p class="edge-panel-empty">{{ 'COMMON.LABEL.NO_RESULTS' | translate }}</p>
        </ng-template>
      </ng-container>

      <ng-template #loadingTpl>
        <div class="edge-panel-loading">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="sr-only">{{ 'COMMON.ACTIONS.LOADING' | translate }}</span>
          </div>
        </div>
      </ng-template>
    </div>
  </aside>
</div>

<!-- Rama del árbol. Se llama a sí misma: el menú puede tener varios niveles y
     los dashboards son categoría → reporte -->
<ng-template #nodeTpl let-nodes="nodes" let-level="level">
  <ul class="edge-panel-list" [class.is-nested]="level > 0">
    <li *ngFor="let n of nodes; trackBy: trackByKey">

      <!-- Nodo con hijos (o que todavía no los pidió): se pliega y despliega -->
      <ng-container *ngIf="hasBranch(n); else leafTpl">
        <div class="edge-panel-branch-row">
          <button type="button" class="edge-panel-branch" [class.is-sub]="level > 0"
                  (click)="toggleNode(n)">
            <i class="feather edge-panel-caret"
               [ngClass]="isCollapsed(n) ? 'icon-chevron-right' : 'icon-chevron-down'"></i>
            <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: n }"></ng-container>
            <span class="edge-panel-branch-name">{{ n.label }}</span>

            <!-- Mientras se pide el contenido de una biblioteca o carpeta -->
            <span class="spinner-border spinner-border-sm text-primary edge-panel-node-spinner"
                  *ngIf="n.loading" role="status"></span>
            <span class="edge-panel-count" *ngIf="!n.loading && n.children?.length">{{ n.children.length }}</span>
          </button>

          <!-- La rama también es un destino (la biblioteca o la carpeta) -->
          <button type="button" class="edge-panel-branch-open" *ngIf="n.url"
                  [attr.title]="n.label"
                  (click)="openNode(n)">
            <i class="feather icon-corner-down-right"></i>
          </button>
        </div>

        <ng-container *ngIf="!isCollapsed(n) && n.children?.length">
          <ng-container *ngTemplateOutlet="nodeTpl; context: { nodes: n.children, level: level + 1 }"></ng-container>
        </ng-container>
      </ng-container>

      <!-- Hoja: navega a su destino -->
      <ng-template #leafTpl>
        <button type="button" class="edge-panel-leaf"
                [class.active]="isActive(n)"
                [attr.title]="n.label"
                [disabled]="!n.url"
                (click)="openNode(n)">
          <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: n }"></ng-container>
          <span class="edge-panel-leaf-name">{{ n.label }}</span>
          <i class="feather icon-external-link edge-panel-external" *ngIf="n.external || n.newTab"></i>
        </button>
      </ng-template>
    </li>
  </ul>
</ng-template>

<!-- Ícono del nodo: el del menú (clase o imagen) o, si no tiene, un puntito -->
<ng-template #iconTpl let-n>
  <!-- Headquarters trae iconos de lucide; el resto del panel, del iconfont -->
  <app-lucide-icon class="edge-panel-icon" [name]="n.icon" [size]="14" *ngIf="n.icon && n.lucide"></app-lucide-icon>

  <img class="edge-panel-icon-img" [src]="n.icon" alt=""
       *ngIf="n.icon && !n.lucide && isImageIcon(n.icon)" />
  <span class="edge-panel-icon" [ngClass]="n.icon"
        *ngIf="n.icon && !n.lucide && !isImageIcon(n.icon) && n.icon.startsWith('fa')"></span>
  <span class="edge-panel-icon" [data-feather]="n.icon" size="14"
        *ngIf="n.icon && !n.lucide && !isImageIcon(n.icon) && !n.icon.startsWith('fa')"></span>
  <span class="edge-panel-bullet" *ngIf="!n.icon"></span>
</ng-template>
